import SpecialColorSliderElementPdp from "./SpecialColorSliderElementPdp";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
export default function SpecialColorSliderPdp({
  products,
  currentProductSku,
  currentProductColor,
}) {
  let specificKey;
  let specificValue;
  if (currentProductColor !== "" && currentProductColor !== undefined) {
    specificKey = "color";
    specificValue = currentProductColor;
  } else {
    specificKey = "sku";
    specificValue = currentProductSku;
  }

  if (products) {
    const specificObject = products.find(
      (obj) => obj[specificKey] === specificValue
    );

    const remainingObjects = products.filter(
      (obj) => obj[specificKey] !== specificValue
    );

    products = [specificObject, ...remainingObjects];
  }

  return (
    <div className="product-variations special-color-slider-pdp">
      <ul className="slides">
        {products?.map((product, index) => {
          return (
            product && (
              <SpecialColorSliderElementPdp
                key={index}
                count={index}
                product={product}
                currentProductSku={currentProductSku}
                currentProductColor={currentProductColor}
              />
            )
          );
        })}
      </ul>
    </div>
  );
}
